import * as React from "react";
import { Route, Routes } from "react-router-dom";
import { ROUTES } from "./routes";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Page404 from "src/components/layout/ErrorPage/PAGE404";
import EventDetail from "./Pages/EventDetail/EventDetail";
import SlotSelection from "./Pages/SlotSelection/SlotSelection";

export const EventsRoutes: React.FunctionComponent = () => {
  return (
    <Routes>
      <Route path={ROUTES.HOME} element={<Dashboard />} />
      <Route path={ROUTES.EVENTS_DASHBOARD} element={<Dashboard />} />
      <Route path={ROUTES.EVENT_DETAIL} element={<EventDetail />} />
      <Route path={ROUTES.EVENT_SLOT_SELECTION} element={<SlotSelection />} />
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};
